import { render, staticRenderFns } from "./LedgerStatement.vue?vue&type=template&id=2223df66&"
import script from "./LedgerStatement.vue?vue&type=script&lang=js&"
export * from "./LedgerStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports